import { ApiClient } from "../../ApiClient"
import { GetSliderResponse } from "../schema/GetSliderResponse"
import { Slide } from "@/@types"
import { mapSlider } from '@/services/api/mappers/sliderMapper';

export const getSlider = async (): Promise<Slide[]> => {
  const client = ApiClient.getInstance()
  const response = await client.get<GetSliderResponse>("home/sliders")

  const sliderItems = response.data.map(mapSlider)

  // Sort slider items by order
  return sliderItems.sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
}